export const CONSENT_GROUPS = {
    functional: 'functional',
    marketing: 'marketing',
    necessary: 'necessary',
    performance: 'performance',
};
const CONSENT_GROUPS_ONE_TRUST = {
    [CONSENT_GROUPS.necessary]: 'C0001',
    [CONSENT_GROUPS.performance]: 'C0002',
    [CONSENT_GROUPS.functional]: 'C0003',
    [CONSENT_GROUPS.marketing]: 'C0004',
};
const CONSENT_COOKIE_NAME = 'OptanonConsent';

function getGroupsGranted() {
    const cookie = useCookie(CONSENT_COOKIE_NAME).value;
    if (!cookie) return [];
    const params = new URLSearchParams(cookie);
    const groupsRaw = params.get('groups');

    if (!groupsRaw) return [];

    return groupsRaw
        .split(',')
        .filter((groupRaw) => groupRaw.includes(':1'))
        .map((groupRaw) => groupRaw.replace(':1', ''));
}

export function hasConsent(group: string | null = null) {
    const groupsGranted = getGroupsGranted();
    if (group) return groupsGranted.includes(CONSENT_GROUPS_ONE_TRUST[group]);

    const groupsGrantedAndRevokable = groupsGranted.filter(
        (g) => g !== CONSENT_GROUPS_ONE_TRUST[CONSENT_GROUPS.necessary],
    );

    return groupsGrantedAndRevokable.length > 0;
}

export const useConsent = () => {
    const hasConsentMarketing = ref(hasConsent(CONSENT_GROUPS.marketing));

    const hasConsentPerformance = ref(hasConsent(CONSENT_GROUPS.performance));
    const hasConsentFunctional = ref(hasConsent(CONSENT_GROUPS.functional));

    const hasConsentGrantedOrDenied = () => {
        return hasConsent(CONSENT_GROUPS.necessary);
    };
    const openSettingsDialog = () => {
        window.OneTrust?.ToggleInfoDisplay();
    };
    return {
        hasConsentFunctional,
        hasConsentGrantedOrDenied,
        hasConsentMarketing,
        hasConsentPerformance,
        openSettingsDialog,
    };
};
